module.exports = __webpack_public_path__ + "img/product_95.3d5eda1.webp";